import { IAsset } from '../../types/model';
import { getLogo } from '../../helpers/functions';

export const Title = ({
  assetType = 'CRYPTO',
  className = '',
  description,
  logo,
  logoRadius = '5',
  title,
  prefix = <></>,
  suffix = <></>,
}: {
  assetType?: IAsset['type'];
  className?: string;
  description?: string;
  logo?: string | null;
  logoRadius?: string;
  title: string;
  prefix?: JSX.Element;
  suffix?: JSX.Element;
}) => {
  return (
    <div className={`${className} flex items-center min-w-0`}>
      {prefix}
      {logo !== undefined && (
        <img
          alt={title}
          className={`
            h-${logoRadius}
            w-${logoRadius}
            ${!suffix && 'ml-5'}
            mr-2
            rounded-full
            bg-black
          `}
          src={getLogo(assetType, logo)}
        />
      )}

      <div className="flex flex-col overflow-hidden">
        <span className={'text-sm font-semibold truncate pr-3'}>{title}</span>

        <span className="text-xs text-grey-50 font-semibold truncate">
          {description}
        </span>
      </div>
      {suffix}
    </div>
  );
};
